function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.26041 1.07151C1.42094 0.983007 1.61652 0.99008 1.77038 1.08995L8.77038 5.63377C8.91349 5.72667 9 5.88667 9 6.05846C9 6.23025 8.91349 6.39025 8.77038 6.48314L1.77038 11.027C1.61652 11.1268 1.42094 11.1339 1.26041 11.0454C1.09987 10.9569 1 10.787 1 10.6023V1.51464C1 1.32995 1.09987 1.16 1.26041 1.07151ZM2 2.43939V9.67753L7.57537 6.05846L2 2.43939Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 2.01953C10.7761 2.01953 11 2.24557 11 2.5244V9.59257C11 9.8714 10.7761 10.0974 10.5 10.0974C10.2239 10.0974 10 9.8714 10 9.59257V2.5244C10 2.24557 10.2239 2.01953 10.5 2.01953Z",
  fill: "white"
});

var SvgResumeIcon = function SvgResumeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResumeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resume-icon.9a96a666.svg";
export { ForwardRef as ReactComponent };